import React, { Component } from 'react'
import PageLogin from '../components/PageLogin'
import { connect } from 'react-redux'
import toJS from './general/toJS'
import { AUTH } from '../constants/state'
import { clearAuthData, requestAuthLoginSession, requestAuthLoginBypass, requestAuthLoginForceSession, requestAuthLoginForceBypass } from '../actions'
import requestStatus from '../constants/requestStatus'

const mapStateToProps = state => ({
    auth: state.get(AUTH),
    translationStringsLoginName: state.getIn(['translation', 'strings', 'login_name']),
    translationStringsLoginPass: state.getIn(['translation', 'strings', 'login_password']),
    translationStringsLoginButton: state.getIn(['translation', 'strings', 'login_button']),
    translationStringsLoginBypass: state.getIn(['translation', 'strings', 'login_button_bypass_text']),
    translationStringCancelButton: state.getIn(['translation', 'strings', 'cancel_button']),
    translationStringForceSession: state.getIn(['translation', 'strings', 'force_session_button']),
    translationStringSessionOtherUser: state.getIn(['translation', 'strings', 'session_other_user']),
    translationStringSessionUsedByOther1: state.getIn(['translation', 'strings', 'session_used_by_other_1']),
    translationStringSessionUsedByOther2: state.getIn(['translation', 'strings', 'session_used_by_other_2']),
    translationStringOtherTab:  state.getIn(['translation', 'strings', 'session_used_in_other_tab']),
    translationStringLoginFailed: state.getIn(['translation', 'strings', 'login_failed']),
    currentLang: state.getIn(['translation', 'currentLang']),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doLoginSession: (userName, userPassword) => {
        dispatch(requestAuthLoginSession(userName, userPassword))
    },

    doLoginForceSession: ()  => {
        dispatch(requestAuthLoginForceSession())
    },

    doLoginBypass: (userName, userPassword) => {
        dispatch(requestAuthLoginBypass(userName, userPassword))
    },

    doLoginForceBypass: () => {
        dispatch(requestAuthLoginForceBypass())
    },

    cancelLoginForce: () => {
        dispatch(clearAuthData())
    }
})


class PageLoginContainer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            userName: '',
            userPassword: '',
        }
    
        this.handleSubmitSession = this.handleSubmitSession.bind(this)
        this.handleSubmitBypass = this.handleSubmitBypass.bind(this)
        this.handleSubmitForce = this.handleSubmitForce.bind(this)
        this.handleCancelForce = this.handleCancelForce.bind(this)
        this.handleChangeUserName = this.handleChangeUserName.bind(this)
        this.handleChangeUserPass = this.handleChangeUserPass.bind(this)
    }

    handleSubmitSession(event) {
        event.preventDefault()

        const { doLoginSession } = this.props
        const { userName, userPassword } = this.state

        doLoginSession(userName, userPassword)

        this.setState({
            userName: '',
            userPassword: ''
        })
    }

    handleSubmitBypass(event) {
        event.preventDefault()

        const { doLoginBypass } = this.props 
        const { userName, userPassword } = this.state

        doLoginBypass(userName, userPassword)

        this.setState({
            userName: '',
            userPassword: ''
        })
    }

    handleSubmitForce(event) {
        event.preventDefault()

        const { auth, doLoginForceSession, doLoginForceBypass } = this.props

        if(auth.session.bypass) {
            doLoginForceBypass()
        } else {
            doLoginForceSession()
        }
    }

    handleCancelForce(event) {
        event.preventDefault()

        const { cancelLoginForce } = this.props 

        cancelLoginForce()

        return false
    }

    handleKeyDown(event) {
        if(event  && event.hasOwnProperty('key') && "Enter" === event.key)  {
    
            event.preventDefault()
            return false
        }
    }

    handleChangeUserName (event) {
        this.setState({
            userName: event.target.value
        })
    }

    handleChangeUserPass(event) {
        this.setState({
            userPassword: event.target.value
        })
    }

    getTransStringFromProp(transProp, fallback) {
        const {currentLang } = this.props

        return transProp && transProp[currentLang] ? transProp[currentLang] : fallback
    }

    getTranslations() {
        const { 
            translationStringsLoginName, 
            translationStringsLoginPass, 
            translationStringsLoginButton, 
            translationStringsLoginBypass,
            translationStringCancelButton,
            translationStringForceSession,
            translationStringSessionOtherUser,
            translationStringSessionUsedByOther1,
            translationStringSessionUsedByOther2,
            translationStringOtherTab,
            translationStringLoginFailed
        } = this.props

        return {
            userNamePlaceholder:    this.getTransStringFromProp(translationStringsLoginName,            'Benutzername'),
            passwordPlaceholder:    this.getTransStringFromProp(translationStringsLoginPass,            'Passwort'),
            submitButtonText:       this.getTransStringFromProp(translationStringsLoginButton,          'Anmelden'),
            bypassText:             this.getTransStringFromProp(translationStringsLoginBypass,          'Ohne Programm bearbeiten'),
            cancelButtonText:       this.getTransStringFromProp(translationStringCancelButton,          'Abbrechen'),
            forceSessionText:       this.getTransStringFromProp(translationStringForceSession,          'Session übernehmen'),
            otherUser:              this.getTransStringFromProp(translationStringSessionOtherUser,      'einem anderen Nutzer'),
            usedByOther1:           this.getTransStringFromProp(translationStringSessionUsedByOther1,   'Backoffice wird von'),
            usedByOther2:           this.getTransStringFromProp(translationStringSessionUsedByOther2,   'genutzt. Login deshalb nicht möglich.'),
            otherTab:               this.getTransStringFromProp(translationStringOtherTab,              'Sie benutzen das Backoffice bereits in einem anderen Tab.'),
            loginFailed:            this.getTransStringFromProp(translationStringLoginFailed,           'Login fehlgeschlagen.'),
        }
    }

    getLoginLevel(transOtherUser, transUsedByOther1, transUsedByOther2, transOtherTab, transLoginFailed) {
        const { auth } = this.props
        let errorMessage 
        let takeOverSession = false

        if(3 === auth.session.state) {
            const sessionUser = auth.session.userName ? auth.session.userName : transOtherUser
            errorMessage = transUsedByOther1 + ' "' + sessionUser + '" ' + transUsedByOther2
        } else if(2 === auth.session.state) {
            errorMessage = transOtherTab
            takeOverSession = true
        } else if( requestStatus.REQUEST_ERROR === auth.status) {
            errorMessage = transLoginFailed
        } else {
            errorMessage = false
        }

        return {
            errorMessage: errorMessage,
            takeOverSession: takeOverSession
        }
    }

    render() {
        const { 
            userNamePlaceholder, 
            passwordPlaceholder,  
            submitButtonText, 
            bypassText,
            cancelButtonText, 
            forceSessionText,
            otherUser,
            usedByOther1,
            usedByOther2,
            otherTab,
            loginFailed
        } = this.getTranslations()
        const { userName, userPassword } = this.state
        const { takeOverSession, errorMessage } = this.getLoginLevel(otherUser, usedByOther1, usedByOther2, otherTab, loginFailed)


        return <PageLogin 
            userName={userName}
            userPassword={userPassword}
            takeOverSession={takeOverSession}
            errorMessage={errorMessage}
            handleSubmitSession={this.handleSubmitSession}
            handleSubmitBypass={this.handleSubmitBypass}
            handleSubmitForce={this.handleSubmitForce}
            handleCancelForce={this.handleCancelForce}
            handleKeyDown={this.handleKeyDown}
            handleChangeUserName={this.handleChangeUserName}
            handleChangeUserPass={this.handleChangeUserPass}
            userNamePlaceholder={userNamePlaceholder}
            passwordPlaceholder={passwordPlaceholder}
            submitButtonText={submitButtonText}
            bypassText={bypassText}
            cancelButtonText={cancelButtonText}
            forceSessionText={forceSessionText}
        />
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(PageLoginContainer))
